export function cleanEmail(email: string) {
	return email.trim()
		.replace(/^[,; ]+|[,; ]+$/g, '')
		.replace(/[;]+/g, ',')
		.replace(/\s+/g, '');
}
